import React from 'react';
import { withRouter } from 'react-router';
import { Card, CardContent, Box, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import LockIcon from '@mui/icons-material/Lock';
import { tracking } from '../../utils/tracking';

const useStyles = makeStyles()(theme => ({
  card: {
    borderRadius: 16,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: 280,
    position: 'relative',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)'
    }
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px !important'
  },
  title: {
    fontWeight: 450,
    color: '#000',
    zIndex: 100
  },
  lockIconContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  curvedLine: {
    position: 'absolute',
    top: 0,
    right: 0,
    borderLeft: '2px solid #666',
    borderBottom: '2px solid #666',
    borderBottomLeftRadius: '75%',
    background: '#666'
  }
}));

const NewDashboardCardWithIconSmall = ({ history, title, img, url, onClick, lock, style = {}, trackingEventName }) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const trackEvent = () => {
    if (trackingEventName) {
      tracking(trackingEventName, {
        Label: title,
        Image: img,
        Target: url
      });
    }
  };

  return (
    <Card
      className={classes.card}
      elevation={0}
      style={{ ...style }}
      onClick={() => {
        trackEvent();
        if (url) history.push(url);
        if (onClick) onClick();
      }}
    >
      {lock && (
        <>
          <Box className={classes.curvedLine} style={{ width: isXsScreen ? 24 : 32, height: isXsScreen ? 24 : 32 }} />
          <Box
            className={classes.lockIconContainer}
            style={{ paddingTop: isXsScreen ? 4 : 6, paddingRight: isXsScreen ? 4 : 6 }}
          >
            <LockIcon style={{ fontSize: isXsScreen ? 14 : 17, color: 'white' }} />
          </Box>
        </>
      )}

      <CardContent className={classes.content}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', minWidth: '140px' }}>
          <img alt={title} src={img} width={36} height={36} />

          <Typography style={{ marginLeft: 10, fontSize: isXsScreen ? 18 : 20 }}> {title} </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default withRouter(NewDashboardCardWithIconSmall);
